import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnablePickBatchOrderGrid = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePickBatchOrderGrid);
};
